<template>
  <div
    class="card-dashboard"
    :class="{ 'status-card': type === 'statusCard' }"
    :style="option ? { '--border-top-color': option.borderColor } : {}"
  >
    <div class="card-dashboard__graph" v-if="type === 'graphCard'">
      <div class="card-dashboard-header" :class="{ 'has-custom-header': $slots.header }">
        <div class="card-dashboard-accent" :style="{ backgroundColor: accentColor }"></div>

        <slot name="header">
          <div class="card-dashboard-title">
            {{ title }}
          </div>
        </slot>
      </div>

      <div class="card-dashboard-divider"></div>

      <slot />
    </div>

    <div
      class="card-dashboard__card"
      v-else-if="option"
      :style="{ 'border-top-color': option.borderColor }"
    >
      <div class="card-status-container">
        <div
          class="card-icon"
          :style="{ 'background-color': hexToRgba(option.backgroundColor, 0.15) }"
        >
          <img :src="option.image" alt="" />
        </div>

        <div class="card-content">
          <div class="card-label" :style="{ color: option.color }">
            {{ option.name.toUpperCase() }}
          </div>

          <div class="card-metric">{{ option.value }} <span class="card-unit">Loads</span></div>

          <div class="card-percentage">{{ option.percentage }}% of total</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardDashboard",

  props: {
    title: String,

    type: String,

    option: Object,

    accentColor: {
      type: String,

      default: "#000033",
    },
  },

  methods: {
    hexToRgba(hex, alpha) {
      if (!hex || typeof hex !== "string" || !hex.startsWith("#")) {
        return `rgba(0, 0, 0, ${alpha})`;
      }
      const r = parseInt(hex.slice(1, 3), 16);
      const g = parseInt(hex.slice(3, 5), 16);
      const b = parseInt(hex.slice(5, 7), 16);
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/_themes" as *;

@use "@/assets/scss/_variables" as *;

@use "@/assets/scss/_dashboard-mixins" as *;

.card-dashboard {
  @include dashboard-card-base;

  &__graph {
    height: auto;
    min-height: inherit;
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  &__card {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 22px;
    position: relative;
  }
}

.card-status-container {
  display: flex;
  align-items: center;

  gap: 11px;

  width: 100%;
}

.card-icon {
  width: 53px;

  height: 53px;

  border-radius: 9px;

  display: flex;

  align-items: center;

  justify-content: center;

  flex-shrink: 0;

  img {
    height: 26px;

    width: 26px;
  }
}

.card-content {
  display: flex;

  flex-direction: column;

  align-items: flex-start;

  flex: 1;
}

.card-label {
  font-weight: 600;

  font-size: 13px;

  text-transform: uppercase;

  letter-spacing: 0.5px;

  margin-bottom: 9px;
}

.card-metric {
  font-size: 22px;

  font-weight: 700;

  color: #000033;

  margin-bottom: 4px;

  line-height: 1;
}

.card-unit {
  font-size: 15px;

  font-weight: 400;

  color: #666;

  margin-left: 4px;
}

.card-percentage {
  font-size: 15px;

  color: #999999;

  font-weight: 400;
}

.card-dashboard-header {
  @include dashboard-card-header;

  &.has-custom-header {
    display: flex;

    justify-content: space-between;

    align-items: center;

    width: 100%;
  }
}

.card-dashboard-accent {
  @include dashboard-accent;
}

.card-dashboard-title {
  @include dashboard-title;
}

.card-dashboard-divider {
  @include dashboard-divider;
}
</style>
